import {
  Box,
  Button,
  CloseButton,
  Flex,
  Text,
  useToast,
} from '@chakra-ui/react';
import { useEffect } from 'react';

export function usePwaUpdateNotification(isEnabled: boolean) {
  const toast = useToast();

  useEffect(() => {
    if (!isEnabled || !('serviceWorker' in navigator)) return;

    const serviceWorker = navigator.serviceWorker;
    let hadServiceWorkerController = Boolean(serviceWorker.controller);

    const handleControllerChange = () => {
      if (!hadServiceWorkerController) {
        hadServiceWorkerController = true;
        return;
      }

      toast({
        title: 'Versi baru tersedia',
        description: 'Muat ulang halaman untuk mendapatkan versi terbaru.',
        status: 'info',
        duration: null,
        isClosable: true,
        render: ({ onClose }) => (
          <Box bg="blue.600" color="white" p={4} borderRadius="md">
            <Flex justify="space-between" align="center">
              <Text fontWeight="semibold">Versi baru tersedia</Text>
              <CloseButton onClick={onClose} />
            </Flex>
            <Button
              mt={2}
              size="sm"
              colorScheme="whiteAlpha"
              onClick={() => window.location.reload()}
            >
              Muat ulang
            </Button>
          </Box>
        ),
      });
    };

    serviceWorker.addEventListener('controllerchange', handleControllerChange);
    return () => {
      serviceWorker.removeEventListener(
        'controllerchange',
        handleControllerChange
      );
    };
  }, [isEnabled, toast]);
}
